import firestore, { firebase } from '@/firebase';
export default {
    state: {
        events: []
    },
    getters: {
        events: state => state.events
    },
    mutations: {
        setEvents(state, events) {
            state.events = events;
        },
        addEvent(state, event) {
            state.events.push(event);
        },
        updateEvent(state, event) {
            const idx = state.events.findIndex(e => e.id === event.id);
            state.events[idx] = event;
            state.events = [...state.events];
        },
        deleteEvent(state, event) {
            const idx = state.events.findIndex(e => e.id === event.id);
            state.events.splice(idx, 1);
            state.events = [...state.events];
        }
    },
    actions: {
        addEvent({ commit }, event) {
            event.createdAt = firebase.firestore.FieldValue.serverTimestamp();
            event.updatedAt = firebase.firestore.FieldValue.serverTimestamp();
            const url = `https://us-central1-xerpa-40c1c.cloudfunctions.net/webapi/v1/event`

            fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(event)
            }).then(res => {
                return res.json();
            })
                .then(event => {
                    commit('addEvent', event);
                })
                .catch(err => {
                    throw Error(err);
                });
        },
        addEventToFavorites({ commit }, event) {
            event.updatedAt = firebase.firestore.FieldValue.serverTimestamp();
            event.isFavorite = !event.isFavorite;
            return firestore.collection("events").doc(event.id).update(event)
                .then(() => {
                    return commit('updateEvent', event);
                });
        },
        updateEvent({ commit }, event) {
            event.updatedAt = firebase.firestore.FieldValue.serverTimestamp();
            return firestore.collection("events").doc(event.id).update(event)
                .then(() => {
                    return commit('updateEvent', event);
                });
        },
        setEvents({ commit }, events) {
            commit('setEvents', events);
        },
        getEvents({ commit }, payload) {
            return firestore
                .collection("events")
                .where("userId", "==", payload.userId)
                .get()
                .then(snapshot => {
                    const personalEvents = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
                    // commit('setEvents', events);

                    return firestore
                        .collection("events")
                        .where("nationalAdminEventOf", "==", payload.specialty)
                        .get()
                        .then(snapshot => {
                            const nationalEvents = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
                            const events = [...personalEvents, ...nationalEvents];
                            commit('setEvents', events);
                        });
                });
        },
        deleteEvent({ commit }, event) {
            firestore.collection("events").doc(event.id).delete().then(() => {
                commit('deleteEvent', event);
            });
        }
    }
}